// ボタンの連打防止
// ボタンに.prevent-double-clickクラスを付与すると、一度クリックしたらボタンが無効化される

export default class PreventDoubleClick {
  constructor() {
    document.addEventListener('DOMContentLoaded', this.preventDoubleClick);
  }

  preventDoubleClick() {
    const targets = Array.from(document.getElementsByClassName('prevent-double-click'));
    targets.forEach((target) => {
      target.addEventListener('mouseup', () => {
        const { disableWith } = target.dataset;
        if (disableWith) {
          target.innerText = disableWith;
        }
        target.click();
        target.style.cursor = 'default';
        target.setAttribute('disabled', true);
      });
    });
  }
}
